import React from 'react';
interface NavigationProps {
  totalSlides: number;
  currentSlide: number;
  setCurrentSlide: (slide: number) => void;
}
export function Navigation({
  totalSlides,
  currentSlide,
  setCurrentSlide
}: NavigationProps) {
  return <div className="flex justify-center mt-8" data-id="element-2">
      <div className="flex space-x-3" data-id="element-3">
        {Array.from({
        length: totalSlides
      }).map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`h-1.5 rounded-full transition-all ${currentSlide === index ? 'w-8 bg-brand-purple' : 'w-4 bg-gray-200 hover:bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-4" />)}
      </div>
    </div>;
}